import './App.css';
import BattleGrowlies from './pages/BattleGrowlies';
import { ChakraProvider } from '@chakra-ui/react'

function App() {
  return (
    <ChakraProvider>
      <BattleGrowlies />
    </ChakraProvider>
  );
}

export default App;
